/* API functions for Datensicherung (Data Backup) */

import { api } from './http';

export interface DatensicherungInfo {
  datum: string;
  dateien: string[];
  gesamtgroesseBytes: number;
}

export async function getDatensicherungList(): Promise<DatensicherungInfo[]> {
  const resp = await api.get<DatensicherungInfo[]>('Datensicherung');
  return resp.data;
}

export async function downloadDatensicherungZip(datum: string): Promise<void> {
  function getBaseURL() {
    const ensureTrailingSlash = (u: string) => (u.endsWith('/') ? u : `${u}/`);
    const raw =
      (import.meta as any).env?.VITE_API_BASE_URL ||
      (typeof window !== 'undefined' ? `${window.location.origin}/api` : '/api');
    const base =
      raw.startsWith('http://') || raw.startsWith('https://')
        ? raw
        : typeof window !== 'undefined'
          ? `${window.location.origin}${raw.startsWith('/') ? '' : '/'}${raw}`
          : raw;
    return ensureTrailingSlash(base);
  }

  const url = new URL(`Datensicherung/${datum}/download`, getBaseURL());
  const token = localStorage.getItem('accessToken');
  const headers: Record<string, string> = {};
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const resp = await fetch(url.toString(), { method: 'GET', headers });
  if (!resp.ok) {
    const text = await resp.text();
    throw new Error(text || `Fehler beim Download (HTTP ${resp.status})`);
  }

  const blob = await resp.blob();
  const objectUrl = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = objectUrl;
  a.download = `datensicherung_${datum}.zip`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(objectUrl);
}
